import { Component, OnInit, Input, SimpleChanges } from "@angular/core";
import { SingleDataSet, Label, MultiDataSet } from "ng2-charts";
import { ChartType, ChartOptions } from "chart.js";
import { GraphicData } from "../../schema/graphic-data";

@Component({
    selector: "app-graphic-pie",
    templateUrl: "./graphic-pie.component.html",
    styleUrls: ["./graphic-pie.component.scss"]
})
export class GraphicPieComponent implements OnInit {
    @Input("data")
    public data: GraphicData;

    public pieChartLabels: Label[];
    public pieChartData: MultiDataSet;
    public pieChartType: ChartType;
    public pieChartLegend: boolean;
    public pieChartPlugins: any[];
    public pieChartOptions: ChartOptions;

    constructor() {
        this.pieChartLabels = [];
        this.pieChartData = [];
        this.pieChartPlugins = [];
        this.pieChartType = "pie";
        this.pieChartLegend = true;
        this.pieChartOptions = { responsive: true };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data && JSON.stringify(changes.data.previousValue) != JSON.stringify(changes.data.currentValue)) {
            this.manageData(changes.data.currentValue);
        }
    }

    ngOnInit() {
        this.manageData(this.data);
    }

    private manageData(data: GraphicData) {
        this.pieChartLabels = [];
        this.pieChartData = [];

        if (data == undefined) return;

        if (data.keys.length <= 0) return;

        const tempValues: number[][] = [];
        const tempLabels: string[] = [];
        data.keys.forEach((key, i) => {
            tempValues.push([]);
            data.group.forEach((group, j) => {
                if (!tempLabels.includes(group.group)) tempLabels.push(group.group);

                tempValues[i].push(group.values[i]);
            });
        });

        this.pieChartLabels = tempLabels;
        this.pieChartData = tempValues;
    }
}
